import React from "react";
import { ToggleProps } from "./Toggle.types";
import { getClassName } from "../../helpers/common.helpers";
import { ToggleCircle } from "../../assets/icons/SvgIcons";
import "./Toggle.scss";

const Toggle = ({ isOn, toggleTitle = "", toggleWrapperClassName = "", toggleClassName = "", toggleCircleClassName = "", toggleTitleClassName = "", onToggleClick }: ToggleProps) => {

    return (
        <div className={getClassName("toggle-wrapper", toggleWrapperClassName)}>
            <span className={getClassName("toggle-wrapper__toggle", toggleClassName)}
                onClick={() => onToggleClick(!isOn)}>
                <div className={isOn ? getClassName("toggle-wrapper__toggle--circle-on", toggleCircleClassName) : getClassName("toggle-wrapper__toggle--circle-off", toggleCircleClassName)}>
                    <ToggleCircle />
                </div>
            </span>
            <span className={getClassName("toggle-wrapper__toggle-title", toggleTitleClassName)}>{toggleTitle}</span>
        </div>

    );
}

export default Toggle;
